import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { Team } from '../../../../context/ApplicationContext/applicationContext.types';
import {
  getBrandInfo,
  getStoreInfo,
} from '../../../../context/ApplicationContext/applicationContext.utils';
import useAppEnvironment from '../../../../context/ApplicationContext/hooks/useAppEnvironment/useAppEnvironment';
import type { SelectModalListItem } from '../../SelectModalList/selectModalList.types';
import { getTeamAvatarColor } from '../teamSelectModal.utils';

type UseTeamSelectModalParams = {
  teams: Array<Team>;
  onClose: () => void;
  onClick?: (team: Team) => void;
};

const useTeamSelectModal = ({ teams, onClose, onClick }: UseTeamSelectModalParams) => {
  const { applyEnvironment } = useAppEnvironment();
  const context = useApplicationContext();

  const handleClick = async (team: Team) => {
    if (onClick) {
      applyEnvironment(team.role, team.brand?.id);
      onClick(team);
      return;
    }

    context.changeTeam(team);
    onClose();
  };

  const items: SelectModalListItem[] = (teams ?? []).map((team) => {
    const brandInfo = getBrandInfo(team.brand);
    const storeInfo = getStoreInfo(team.store);
    const logoUrl = brandInfo.logoUrl || storeInfo.logoUrl;
    const displayName = brandInfo.name || storeInfo.name || team.roleName;

    return {
      id: team.id,
      primary: displayName,
      avatarSrc: logoUrl,
      avatarInitials: displayName[0]?.toUpperCase(),
      avatarSx: { background: (theme) => getTeamAvatarColor({ team, theme, hasLogo: !!logoUrl }) },
      onSelect: () => handleClick(team),
    };
  });

  return { items };
};

export default useTeamSelectModal;
